import { FC } from 'react';
import { IMeal } from '../../../../types/camp.types';
import { StyleSheet, TextStyle, View, ViewStyle } from 'react-native';
import { useIsDesktop } from '../../../../hooks/useIsDeskTop';
import { Text } from '../../../../components/Text';
import { MealItem } from './MealItem';
import { COLORS, FONTS } from '../../../../constants';
import { STYLE_VARS } from '../../../../constants/style-vars';

export const InCludedMealItem: FC<{
  name: string;
  meal: IMeal;
  mealWrapperStyle?: ViewStyle;
  mealTextStyle?: TextStyle;
  zIndex: number;
}> = ({ name, meal, mealWrapperStyle, mealTextStyle, zIndex }) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={[
        styles.mealContainer,
        isDesktop()
          ? {
              width: 320,
            }
          : {
              width: '100%',
            },
      ]}
    >
      <View style={[styles.mealWrapper, mealWrapperStyle]}>
        <Text
          style={[
            styles.mealText,
            mealTextStyle,
            !isDesktop() && { fontSize: 17 },
          ]}
        >
          {name}
        </Text>
      </View>
      <View style={{ width: '60%' }}>
        <MealItem meal={meal} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mealContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  mealWrapper: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 16,
  },
  mealText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 20,
    lineHeight: 31,
  },
  countContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  countBtn: {},
  countBtnIcon: {
    width: 20,
    height: 20,
  },
  countNumber: {
    fontSize: 12,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
});
